export class BrandPage {
  init(): void {
    // ブランド一覧ページ
  }
}
